import { useMemo } from 'react';
import { buildAchievements } from '../utils/buildAchievements';

export function useAchievements({ allTxns, selMonth, selYear, incomeList, savingsRate }) {
  return useMemo(
    () => buildAchievements(allTxns, selMonth, selYear, incomeList, savingsRate),
    [allTxns, selMonth, selYear, incomeList, savingsRate]
  );
}
